import { GTMClasses, providerTypes, SeFriendlyPageType } from './constants'

const SE_FRIENDLY_PUBLIC_PATH = /^\/(therapists|psychiatrists)(\/|$)/i

/**
 * Detects SE-friendly routes using both the internal page pathname and the
 * public URL. Rewrites expose `/therapists/...` in the browser while the page
 * file lives under `/se-friendly/...`; relying on pathname alone can disagree
 * between SSR and hydration and swap the footer phone number.
 */
export const isSeFriendlyRoute = (
  pathname: string,
  asPath: string
): boolean => {
  if (pathname.includes('se-friendly')) {
    return true
  }

  const publicPath = asPath.split('?')[0].split('#')[0]

  return SE_FRIENDLY_PUBLIC_PATH.test(publicPath)
}

export const getHeroSubContentTextItems = (
  sefriendlyPageType: string,
  sefriendlyProvidersType?: string
): string[] => {
  const isPsychiatristsPage =
    sefriendlyProvidersType === providerTypes.PSYCHIATRISTS

  const defaultHeroSubContentTextItems = [
    'We’re #1 for in-network coverage—accepted by most major insurance plans*',
    '3 in 5 patients report feeling better after only three sessions',
    `Same-day, same-week, evening, or weekend online ${
      isPsychiatristsPage ? 'psychiatry' : 'therapy'
    } appointments available`,
  ]
  const hubPageLastSubContentTextItem = isPsychiatristsPage
    ? 'Weekend & evening sessions – access care via video, saving you travel time'
    : 'Flexible therapy options – choose from in-person or online sessions, available on weekends and evenings too'

  if (sefriendlyPageType === SeFriendlyPageType.STATE) {
    return [
      `${
        isPsychiatristsPage
          ? 'Convenient online psychiatry'
          : 'In person or online therapy'
      } appointments`,
      'Get help when & where you need it — within 7 days of scheduling',
      `Weekend & evening appointments`,
    ]
  } else if (sefriendlyPageType === SeFriendlyPageType.HUB) {
    const hubPageHeroSubContentTextItems = [
      ...defaultHeroSubContentTextItems.slice(0, -1),
      hubPageLastSubContentTextItem,
    ]
    return hubPageHeroSubContentTextItems
  }

  return defaultHeroSubContentTextItems
}

export const getBookBannerCTAClassNames = (
  sefriendlyPageType: string,
  sefriendlyProvidersType: string
): SefriendlyBookBannerCTAClassNames => {
  const bookBannerCTAClassNames = {
    findProviderCTA: GTMClasses.CTA_BOOK_BANNER_FIND_PROVIDER,
    callNumberCTA: GTMClasses.CTA_BOOK_BANNER_CALL_NUMBER,
  }

  if (sefriendlyPageType === SeFriendlyPageType.HUB) {
    if (sefriendlyProvidersType === providerTypes.THERAPISTS) {
      bookBannerCTAClassNames.callNumberCTA =
        GTMClasses.CTA_THERAPIST_HUB_BOOK_BANNER_CALL_NUMBER
      bookBannerCTAClassNames.findProviderCTA =
        GTMClasses.CTA_THERAPIST_HUB_BOOK_BANNER_FIND_PROVIDER
    } else if (sefriendlyProvidersType === providerTypes.PSYCHIATRISTS) {
      bookBannerCTAClassNames.callNumberCTA =
        GTMClasses.CTA_PSYCHIATRIST_HUB_BOOK_BANNER_CALL_NUMBER
      bookBannerCTAClassNames.findProviderCTA =
        GTMClasses.CTA_PSYCHIATRIST_HUB_BOOK_BANNER_FIND_PROVIDER
    }
  }

  return bookBannerCTAClassNames
}
